import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-settings'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_ai_settings_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'settings_ai_settings_index', params: to.params };
          },
        },
        {
          path: 'index',
          name: 'settings_ai_settings_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
